'use strict';

/*
DOCUMENT ME
*/

define('modules/module.favorites',[
  'jquery',
  './module',
  'txt!./module.favorites.empty.hbs',
  'txt!./module.favorites.hbs',
  'txt!./module.loader.hbs',
  'features/favorites',
  'components/slicker',
  'lib/util/tda.config',
  'lib/page-cache',
  'lib/util/langFromUrl'
], function ($,
  Module,
  txtTemplateEmpty,
  txtTemplate,
  txtModuleLoader,
  favorites,
  Slicker,
  tdaConfig,
  PageCache,
  langFromUrl) {
  var __tmplLoader = Handlebars.compile(txtModuleLoader);
  var __tmplBodyEmpty = Handlebars.compile(txtTemplateEmpty);
  var __tmplBody = Handlebars.compile(txtTemplate);

  /* TODO: move this out to a shared offer.defaultDetailPath lib ? */
  function __offerImgPaths(series) {
    if (!series) return '/assets/img/vehicles/multivehicle_default.png';
    var dir = series.toLowerCase().replace(' ', '');
    return '/assets/img/vehicles/' + dir + '/default-offer-detail.png';
  }

  /*
  Favs module does NOT show  certain offer types (or any multivehicle offer). Remove them here.
  multivehicle is NOT an offerType (at least at this point in time).
  All we can do is look at the offerId to determine that.
  OR should we really just be checking if series is empty string?
  PLUS, will this work for BOAT offers too? (can we rely on ID)
  */
  function __removeUnwantedFavs(favsArr) {
    var unwantedTypes = ['msrp', 'misc'];
    var unwantedId = 'multiple_vehicle';
    var noWammies = favsArr.filter(function (item, idx, arr) {
      if (unwantedTypes.indexOf(item.type) === -1 && item.id.indexOf(unwantedId) === -1) {
        return true;
      }
      return false;
    });
    return noWammies;
  }

  function __checkExpire(item) {
    var expires = new Date(item.expire + '/23:59:59'); // alt: '12-31-17T23:59:59'
    var today = new Date();
    if (today.getTime() > expires.getTime()) {
      return true;
    }
    return false;
  }

  // comes in as 12/31/2018 (nearly 100% of the time!)
  function __expireShort(expire) {
    var expires = new Date(expire);
    var month = ('0' + (expires.getMonth() + 1)).slice(-2);
    var day = ('0' + expires.getDate()).slice(-2);
    return month + '/' + day;
  }

  function __seriesSetExpiredAll(favsArr) {
    favsArr.forEach(function (item, idx, ogArr) {
      if (item.expiredCount === item.offerIds.length) {
        item.allSeriesExpired = true;
      } else {
        item.allSeriesExpired = false;
      }
    });
    return favsArr;
  }

  /*
  FINALLY. if every single item in our favsArr contains the allSeriesExpired prop,
  we need to change our context of the HBS to "ALL of your favorites in each set of series, have expired!"
  */
  function __allFavsHaveExpired(favsArr) {
    var expiredSets = [];
    favsArr.forEach(function (item) {
      if (item.allSeriesExpired) expiredSets.push(item);
    });
    if (expiredSets.length === favsArr.length) {
      return true;
    }
    return false;
  }

  function __buildExpireCta(seriesCode) {
    var cta = {
      en: {
        title: 'View <span class="break">Available Offers</span>',
        url: '/' + tdaConfig.site.context_url + '/offers/' + seriesCode
      },
      es: {
        title: 'Ofertas <span class="break">disponible</span>', // taken from LSDS
        url: '/' + tdaConfig.site.context_url + '/offers/' + seriesCode
      }
    };
    return cta[langFromUrl()];
  }

  function __favsXform(favsArr) {
    var favObj = {};
    favObj._favs = favsArr;
    favsArr = __removeUnwantedFavs(favsArr);

    favsArr.forEach(function (item, idx, arr) {
      item.expired = __checkExpire(item);
    });

    // produce an obj out of .reduce with keys of 'year+series' that were gathered together (accumulated!).
    var reduced = favsArr.reduce(function (acc, fav, idx, ogArr) {
      fav.series = fav.series.toString();
      var key = fav.year + fav.series;
      if (!key) key = fav.type; // accumulate on offerType if we couldnt use a key

      // if this one exists, update it
      if (acc[key]) {
        acc[key].offerIds.push(fav.id);
        acc[key].expirations.push({ 'expireShort': __expireShort(fav.expire), 'expire': fav.expire });
        acc[key].timestamp = fav.timestamp;
        // if this fav is expired, do NOT update our offerTypes OBJ. But we still need it in our accumulated obj!
        if (fav.expired) {
          acc[key].expiredCount = acc[key].expiredCount + 1;
        } else {
          acc[key].expiredCount = acc[key].expiredCount;
          acc[key].offerTypes[fav.type] = (acc[key].offerTypes[fav.type] || 0) + 1; // add this offer type, or increment it
        }

      // if this one does not exist, add it
      } else {
        acc[key] = {
          series: fav.series,
          year: fav.year,
          offerIds: [fav.id],
          expirations: [{ 'expireShort': __expireShort(fav.expire), 'expire': fav.expire }],
          offerTypes: {},
          expiredCount: (fav.expired ? 1 : 0),
          timestamp: fav.timestamp,
          hero: __offerImgPaths(fav.series),
          expireCta: __buildExpireCta(fav.series.replace(' ', '').toLowerCase())
        };

        // only count it if its not expired
        if (!fav.expired) {
          acc[key].offerTypes[fav.type] = 1;
          // acc[key].offerTypes[fav.type] = 0;
        }
      }
      acc[key].offerTypeCount = Object.keys(acc[key].offerTypes).length; // tack on the # of diff offer types we have
      return acc;
    }, {});

    var finalFavs = Object.keys(reduced).map(function (item) {
      return reduced[item];
    });

    finalFavs = __seriesSetExpiredAll(finalFavs);
    // sort finalFavs using their timestamp
    finalFavs.sort(function (obj1, obj2) {
      return obj2.timestamp - obj1.timestamp;
    });
    // only 5 of them!
    favObj.favs = finalFavs.slice(0, 5);
    return favObj;
  }

  var FavoritesModule = Module.extend({
    template: __tmplLoader,
    events: function () {
      return Object.assign({}, Module.prototype.events, {
        'click .module-cta-0': 'onViewClicked',
      });
    },

    staticData: {
      all: {
        subtextIcon: '/assets/img/module/favorites/icon-FavoriteOffers.svg'
      },
      en: {
        headline: {
          '1x1': 'Save your Favorite Offers',
          '2x1': 'Save the Savings for Later '
        },
        subtext: 'Saved Offers',
        copy: {
          '1x1': '<p>Don’t let Toyota deals get away. Save your favorite offers and easily find them later.</p>',
          '2x1': '<p>Don’t let Toyota deals get away. Save your favorite Toyota offers so you can easily find them later.</p>'
        }
      },
      es: {
        headline: {
          '1x1': 'Guardar ofertas favoritas',
          '3x1': 'Guardar ofertas favoritas'
        },
        subtext: 'Guarda tu favorita',
        copy: {
          '1x1': '<p>Guarda tus ofertas Toyota favoritas para hallarlas después fácilmente y aprovecharlas.</p>'
        }
      }
    },

    updateStaticData: function (hasFavsForDisplay) {
      /*
      Extend staticData[currentLang] with proper actions (and copyMore)
      Depending on if we have favorites for display or not
      */
      $.extend(this.staticData.en, {
        actions: [{
          title: 'Find Toyota Offers Nearby',
          url: '/' + tdaConfig.site.context_url + '/offers'
        }],
        copyMore: {
          expiredHeadline: 'Your recently Favorited Offers have <span>Expired</span>.',
          offersExpiring: 'Offers Expiring',
          expiredNotice: 'Offer(s) Expired'
        }
      });

      $.extend(this.staticData.es, {
        actions: [{
          title: 'Ofertas Toyota cercanas',
          url: '/' + tdaConfig.site.context_url + '/offers'
        }],
        copyMore: {
          expiredHeadline: 'Your recently Favorited Offers have <span>Expired</span>.',
          offersExpiring: 'Offers Expiring',
          expiredNotice: 'Offer(s) Expired'
        }
      });

      // if we have favs AND all favs have NOT expired, update module CTA. Otherwise use the default
      if (hasFavsForDisplay && !__allFavsHaveExpired(this.result.favs)) {
        $.extend(this.staticData.en, {
          actions: [{
            title: 'View Saved Offers',
            url: '/' + tdaConfig.site.context_url + '/favorites'
          }]
        });

        $.extend(this.staticData.es, {
          actions: [{
            title: 'View Saved Offers',
            url: '/' + tdaConfig.site.context_url + '/favorites'
          }]
        });
      }
    },

    initialize: function (canvas, config, idx) {
      Module.prototype.initialize.apply(this, arguments); // Call the supers initialize
      var self = this;
      self.result = '';
      self.listeners();
      if (favorites.favCount) {
        self.checkFavsForModule();
      } else {
        this.displayNoFavs();
      }
    },

    listeners: function () {
      // Listen for favs add/remove via PageCache
      var self = this;
      PageCache.on('favs.store', function (favsStore) {
        if (favsStore.length) {
          self.checkFavsForModule();
        } else {
          self.displayNoFavs();
        }
      });
    },

    resize: function () {
      Module.prototype.resize.apply(this, arguments);
      this.slideShow();
    },

    checkFavsForModule: function () {
      var freshFavs = PageCache.has('favs.store') ? PageCache.get('favs.store') : favorites.gimmeFavs;
      this.result = __favsXform(freshFavs);
      // we may HAVE favs, but they may not be favs that we display in the favs module.
      if (this.result.favs.length) {
        this.displayFavs();
      } else {
        this.displayNoFavs();
      }
    },

    displayFavs: function () {
      this.setTemplate(__tmplBody);
      this.slideShow();
    },

    displayNoFavs: function () {
      this.result = ''; // empty the results
      this.setTemplate(__tmplBodyEmpty);
    },

    getTemplateContext: function () {
      this.updateStaticData(this.result && this.result.favs.length);
      var ctx = $.extend({}, this.staticData.all, this.staticData[this.getCanvas().getLang()], this.getConfig().data);
      ctx.result = this.result; // update the context with our result
      // console.log('HBS CTX: ', ctx);
      return ctx;
    },

    // layout is called AFTER resize
    layout: function () {
      this.slideShow();
    },

    slideShow: function () {
      var self = this;
      var imageSlides = new Slicker({
        $slider: $('.module-slideshow', self.$el),
        slickOptions: {
          mobileFirst: true,
          fade: true,
          slide: '.module-slide',
          slidesToShow: 1,
          infinite: true,
          autoplay: false,
          arrows: true,
          dots: true,
          asNavFor: $('.module-slideshow-copy', self.$el),
          appendArrows: $('.module-slideshow-arrows-cont', self.$el),
          prevArrow: '<div class="mod-prev"><button><i class="icon icon-arrow-thin-left"></i></button></div>',
          nextArrow: '<div class="mod-next"><button><i class="icon icon-arrow-thin-right"></i></button></div>'
        }
      });

      var copySlides = new Slicker({
        $slider: $('.module-slideshow-copy', self.$el),
        slickOptions: {
          mobileFirst: true,
          fade: true,
          slide: '.module-slide',
          slidesToShow: 1,
          infinite: true,
          autoplay: false,
          arrows: false,
          dots: false,
          adaptiveHeight: true,
          prevArrow: '<div class="mod-prev"><button><i class="icon icon-arrow-thin-left"></i></button></div>',
          nextArrow: '<div class="mod-next"><button><i class="icon icon-arrow-thin-right"></i></button></div>'
        }
      });
    },

    onViewClicked: function (e) {
      // set a cookie with selected grade in it to filter on that grade (see inventory search results)
      if (tdaConfig.tda.code == 'WWW') {
        e && e.preventDefault();
        // If we are on WWW, show the zip dialog
        zipTools.promptUserForZip(zip.getCookiedDefaultFallback(), $(e.currentTarget).attr('href'));
      }
    },
  });

  return FavoritesModule;
});

